import { SET_CUSTOMER_POOLS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_CUSTOMER_POOLS:
      return action.payload;
    default:
      return state;
  }
};
